'use client';
import Link from 'next/link';
// Frontière d'erreur — en PRODUCTION l'overlay de développement Next est
// désactivé : sans ce fichier, une exception non capturée laisse un écran BLANC
// muet (constat QA v2). On affiche une page lisible ET on journalise l'erreur.
import { useEffect } from 'react';

export default function Error({ error, unstable_retry }: { error: Error & { digest?: string }; unstable_retry: () => void }) {
  useEffect(() => {
    console.error('[bio24] erreur applicative non capturée :', error);
  }, [error]);

  return (
    <div style={{ minHeight: '70vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24, fontFamily: 'var(--font-sans, system-ui)' }}>
      <div style={{ maxWidth: 460, textAlign: 'center' }}>
        <div style={{ width: 56, height: 56, borderRadius: 14, background: 'var(--red-50, #fbeaea)', color: 'var(--red-600, #c0392b)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: 28, fontWeight: 700 }}>!</div>
        <h1 style={{ fontSize: 22, fontWeight: 700, color: 'var(--text-strong, #16202a)', margin: '20px 0 0' }}>Une erreur est survenue</h1>
        <p style={{ fontSize: 14.5, lineHeight: 1.6, color: 'var(--text-body, #47535e)', margin: '10px 0 0' }}>
          L’affichage a été interrompu par une erreur inattendue. Réessayez, ou revenez au tableau de bord qualité.
        </p>
        {error?.digest && (
          <p style={{ fontSize: 12.5, fontFamily: 'var(--font-mono, monospace)', color: 'var(--text-muted, #7a8894)', margin: '12px 0 0' }}>
            Référence : {error.digest}
          </p>
        )}
        <div style={{ display: 'flex', gap: 10, justifyContent: 'center', marginTop: 22, flexWrap: 'wrap' }}>
          <button onClick={() => unstable_retry()} style={{ fontFamily: 'inherit', fontSize: 14, fontWeight: 600, border: 'none', background: 'var(--color-primary, #1f6feb)', color: '#fff', borderRadius: 10, padding: '11px 22px', cursor: 'pointer' }}>Réessayer</button>
          {/* `Link` et non `<a>` : un lien HTML nu recharge toute l'application
              au lieu de naviguer, et c'est justement depuis un écran d'erreur
              qu'on veut éviter un rechargement complet. */}
          <Link href="/" style={{ fontFamily: 'inherit', fontSize: 14, fontWeight: 600, border: '1.5px solid var(--border-default, #d6e1e9)', background: '#fff', color: 'var(--text-strong, #16202a)', borderRadius: 10, padding: '11px 22px', textDecoration: 'none' }}>Tableau de bord</Link>
        </div>
      </div>
    </div>
  );
}
